/**
 * Opens product image lightbox as a Fancybox gallery (prev/next, swipe, keyboard).
 * Only active when modal-opener has data-product-lightbox (image_zoom: lightbox).
 */
function openProductLightbox(galleryId, mediaId) {
  if (!window.jQuery?.fancybox) return false;

  const slides = [];
  let startIndex = 0;

  document.querySelectorAll(`[data-product-lightbox="${galleryId}"]`).forEach((opener) => {
    const slide = opener.closest('.product__media-item');
    if (slide?.classList.contains('product__media-item--variant')) return;

    const button = opener.querySelector('button[data-media-id]');
    const src = opener.dataset.lightboxSrc;
    if (!button || !src) return;

    if (button.getAttribute('data-media-id') === mediaId) {
      startIndex = slides.length;
    }

    slides.push({
      src,
      type: 'image',
      caption: opener.dataset.lightboxCaption || '',
    });
  });

  if (!slides.length) return false;

  window.jQuery.fancybox.open(slides, {
    loop: true,
    index: startIndex,
    infobar: true,
    buttons: ['slideShow', 'fullScreen', 'thumbs', 'close'],
    thumbs: { autoStart: false },
    transitionEffect: 'slide',
    animationEffect: 'fade',
  });

  return true;
}

function onProductLightboxClick(event) {
  const button = event.target.closest('.product__modal-opener--image button[data-media-id]');
  if (!button) return;

  const opener = button.closest('[data-product-lightbox]');
  if (!opener) return;

  if (!openProductLightbox(opener.getAttribute('data-product-lightbox'), button.getAttribute('data-media-id'))) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
}

document.addEventListener('click', onProductLightboxClick, true);
